export enum CompetitionPeriodEnum {
  PREVIOUS = "PREVIOUS",
  CURRENT = "CURRENT"
}